var UserGroupLegacyModule = /** @class */ (function () {
    function UserGroupLegacyModule() {
    }
    return UserGroupLegacyModule;
}());
export { UserGroupLegacyModule };
